import { createFileRoute } from '@tanstack/react-router';
import { MyPlanSkeleton } from 'pages/my-plan/components/skeleton';
import { lazy, Suspense } from 'react';

const MyPlan = lazy(() => import('pages/my-plan'));

export const Route = createFileRoute('/_authenticated/_main/my-plan')({
  component: MyPlanWrapper,
});

function MyPlanWrapper() {
  return (
    <Suspense fallback={<MyPlanSkeleton />}>
      <MyPlan />
    </Suspense>
  );
}
